const layout = {
  profile: '个人中心',
  upgrade: '购买 / 升级',
  buy_plan: '购买/升级',
  buy_entitlement: '购买独立权益包',
  brand_product: '达人建联',
  support: '支持',
  user_menu: '用户菜单',
  role_admin: '管理员',
  menu_workbench: '工作台',
  menu_store: '店铺授权',
  menu_talent: '达人广场',
  menu_creator: '达人管理',
  menu_invitation: '邀约',
  menu_dm: '私信',
  menu_email: '邮箱',
  menu_script: '话术',
  no_shop: '暂无店铺',
  shop_load_failed: '店铺列表加载失败'
};

export default layout;
